import type { FaqItem } from '../types/offer'

export const faqs: FaqItem[] = [
  {
    id: 'hardware',
    question: '¿Necesito una computadora potente?',
    answer:
      'No. Todo se hace en la nube (Midjourney, Runway, etc.). Puedes hacerlo desde tu laptop o tablet.'
  },
  {
    id: 'principiante',
    question: '¿Soy principiante, esto es para mí?',
    answer:
      'Sí. Los 600+ prompts están listos para copiar y pegar. No necesitas experiencia previa.'
  },
  {
    id: 'precio',
    question: '¿Por qué tan barato?',
    answer:
      'Queremos que el acceso no sea una excusa. Preferimos 1,000 personas en nuestra comunidad Skool aportando valor que 10 pagando caro.'
  },
  {
    id: 'updates',
    question: '¿Los prompts se actualizan?',
    answer:
      'Sí, dentro de la comunidad de Skool publicamos los nuevos descubrimientos cada semana.'
  }
]
